import { Component, Input, ViewChild } from '@angular/core';
import { ButtonComponent } from 'components/input/button/button.component';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { CustomSelectComponent } from 'components/input/custom-select/custom-select.component';
import { BcDocumentLineType } from 'enums/BcDocumentLineType';
import { InputType } from 'enums/InputType';
import { ValidationType } from 'enums/validationType';
import { AccountingPlanSetupModel } from 'models/generated/Entities.Accounting.AccountingPlanSetup';
import { ProductModel } from 'models/generated/Entities.GormCrm.Product';
import { SelectListItemModel } from 'models/SelectList';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { AccountingService } from 'services/accounting.service';
import { InvoicingService } from 'services/invoicing.service';
import { FormValidationService } from 'services/form-validation.service';
import { NotificationService } from 'services/notification.service';
import { ProductService } from 'services/product.service';

@Component({
	selector: 'accounting-plan-setup',
	templateUrl: './accounting-plan-setup.component.html',
	providers: [FormValidationService],
	imports: [Layout, CustomInputComponent, CustomSelectComponent, TranslatePipe]
})
export class AccountingPlanSetupComponent {

	@ViewChild('saveButton') saveButton!: ButtonComponent;

	validationType = ValidationType;
	_accountingPlanSetup!: AccountingPlanSetupModel;
	productDimensionsSelect: SelectListItemModel[] = [];
	exportTypeSelect: SelectListItemModel[] = [];
	exportTypeNoSelect: SelectListItemModel[] = [];
	selectedProductDimension?: string;
	selectedExportType?: BcDocumentLineType;
	selectedExportTypeNo?: string;
	inputType = InputType;
	products?: ProductModel[];

	async confirmDelete() {
		this.notificationService.confirm('accounting-plan-setup.delete-confirm').subscribe(result => {
			if (result) this.deleteAccountingPlanSetup();
		});
	}

	@Input()
	set accountingPlanSetup(setup: AccountingPlanSetupModel) {
		this._accountingPlanSetup = structuredClone(setup);
		this.selectedProductDimension = setup.productDimensionCode;
		this.selectedExportType = setup.exportType;
		this.selectedExportTypeNo = setup.exportTypeNo;

		this.invoicingService.getProductDimensionsSelectList().then(dimensionValues => this.productDimensionsSelect = dimensionValues);
		this.getExportTypes();
		this.getExportTypeNo();
	}
	get accountingPlanSetup() {
		return this._accountingPlanSetup!;
	}

	constructor(
		private readonly accountingService: AccountingService,
		private readonly translate: TranslatePipe,
		private readonly notificationService: NotificationService,
		private readonly invoicingService: InvoicingService,
		productService: ProductService) {

		productService.getAllActiveProducts().then(products => { this.products = products; });
	}

	getExportTypes() {
		this.exportTypeSelect = [];
		this.exportTypeSelect.push(new SelectListItemModel(BcDocumentLineType.Account, this.translate.transform('accounting-plan-setup.exportType.gl-account')));
		this.exportTypeSelect.push(new SelectListItemModel(BcDocumentLineType.Item, this.translate.transform('accounting-plan-setup.exportType.item')));
	}

	getExportTypeNo() {
		this.exportTypeNoSelect = [];
		this.exportTypeNoSelect.push(new SelectListItemModel('11200', this.translate.transform('accounting-plan-setup.exportTypeNo.11200')));
		this.invoicingService.getBcItemsSelectList().then(items => this.exportTypeNoSelect.push(...items));
	}

	saveAccountingPlanSetup() {
		this.accountingPlanSetup.exportType = this.selectedExportType!;
		this.accountingPlanSetup.exportTypeNo = this.selectedExportTypeNo!;
		this.accountingPlanSetup.productDimensionCode = this.selectedProductDimension!;

		this.accountingService.saveAccountingPlanSetup(this.accountingPlanSetup).then((accountingPlanSetup) => {
			this.accountingPlanSetup = accountingPlanSetup;
			this.saveButton.succeeded();
		});
	}

	canBeDeleted(): boolean | void {
		if (!this.accountingPlanSetup || !this.products) return;
		if (this.products.some(p => p.accountingPlanSetupId === this.accountingPlanSetup.id)) return false;
		return true;
	}

	deleteAccountingPlanSetup() {
		this.accountingService.deleteAccountingPlanSetup(this.accountingPlanSetup.id!);
	}

	loadingDone(): boolean {
		return this.productDimensionsSelect.length > 0 && this.exportTypeNoSelect.length > 0 && this.exportTypeSelect.length > 0 && this.accountingPlanSetup != undefined;
	}

	getHeader(): string {
		return this.accountingPlanSetup.id ? this.translate.transform('accounting-plan-setup.edit') : this.translate.transform('accounting-plan-setup.create');
	}
}
